<template>
  <el-row :gutter="elGutter" class="public-navs">
    <el-col :span="elSpan" v-for="(item, idx) of toolsList" :key="item.id"
      :class="{ cur: $route.meta.active === item.pname }">
      <el-card shadow="always" @mouseover.native="toolMouseOver(idx)" @mouseleave.native="toolMouseLeave(idx)">
        <!-- <template v-if="item.pname == 'LivePage'||item.pname == 'QuestionsPage'">
                    <a :href="item.url"  target="_blank"  class="lk">
                        <div class="tool-item">
                            <div class="icon">
                                <img
                                    :src="
                                        item.hoverIcon
                                            ? item.hoverIcon
                                            : item.icon
                                    "
                                    alt=""
                                />
                            </div>
                            <div class="tool-text">
                                <h2 class="tit">{{ item.title }}</h2>
                                <span class="sub">{{ item.subTitle }}</span>
                            </div>
                        </div>
                    </a>
                </template> -->
        <template>
          <!-- <router-link :to="{ path: item.name }" class="lk"> -->
          <div @click="jumpTo(item.pname)" class="tool-item">
            <div class="icon">
              <img :src="item.hoverIcon ? item.hoverIcon : item.icon" alt="" />
            </div>
            <div class="tool-text">
              <h2 class="tit">{{ item.title }}</h2>
              <span class="sub">{{ item.subTitle }}</span>
            </div>
          </div>
          <!-- </router-link> -->
        </template>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
  import store from "@/store"
  import CurrentConferMixin from "@/mixin/CurrentConference"

  export default {
    name: "ToolNav",
    props: {
      elGutter: {
        type: [String, Number],
        default: 1,
      },
      elSpan: {
        type: [String, Number],
        default: 4,
      },
    },
    mixins: [CurrentConferMixin],
    data() {
      return {
        toolsList: [
          {
            id: 1,
            name: "registration",
            pname: "RegistrationPage",
            icon: require("@assets/img/tool-nav1.png"),
            hoverIcon: "",
            title: "我的报名",
            subTitle: "My registration ",
          },
          {
            id: 2,
            name: "meeting",
            pname: "MeetingPage",
            icon: require("@assets/img/tool-nav2.png"),
            hoverIcon: "",
            title: "会议信息",
            subTitle: "Meeting information ",
          },
          {
            id: 3,
            name: "live",
            pname: "LivePage",
            icon: require("@assets/img/tool-nav3.png"),
            hoverIcon: "",
            title: "会议直播",
            subTitle: "Live streaming of the conference ",
            url: "",
          },
          {
            id: 4,
            name: "papers",
            pname: "PapersPage",
            icon: require("@assets/img/tool-nav4.png"),
            hoverIcon: "",
            title: "论文投稿",
            subTitle: "Submission of papers",
          },
          {
            id: 5,
            name: "projectVisit",
            pname: "ProjectVisitPage",
            icon: require("@assets/img/tool-nav5.png"),
            hoverIcon: "",
            title: "项目参观",
            subTitle: "Project visit",
          },
          {
            id: 6,
            name: "questions",
            pname: "QuestionsPage",
            icon: require("@assets/img/tool-nav6.png"),
            hoverIcon: "",
            title: "调查问卷",
            subTitle: "Questionnaire",
            url: "",
          },
        ],
      }
    },
    //  watch: {
    //     currentConference: {
    //         handler(val) {

    //             this.toolsList[2].url = val.liveurl
    //             this.toolsList[5].url = val.surveyurl
    //         },
    //         deep: true,
    //     },
    // },

    methods: {
      toolMouseOver(idx) {
        setTimeout(() => {
          this.toolsList[idx].hoverIcon = require(`@assets/img/tool-nav-white${idx + 1
            }.png`)
        }, 100)
      },
      toolMouseLeave(idx) {
        setTimeout(() => {
          this.toolsList[idx].hoverIcon = ""
        }, 100)
      },
      jumpTo(path) {
        let token = store.getters["auth/token"] || null
        let authorized = token && token.checkValid()
        //我的报名(需要登录)，论文投稿(需要登录)，调查问卷(需要登录，且会议开始后才能填写)，项目参观(需要登录)
        if (path == "RegistrationPage" || path == "PapersPage" || path == "QuestionsPage" || path == "ProjectVisitPage") {
          if (authorized) {
            if (path == "QuestionsPage") {
              if (this.$store.state.conference.currentConference) {
                let opendate = new Date(this.currentConference.conferencedate)
                opendate.setHours(0, 0, 0, 0);
                let today = new Date();
                today.setHours(0, 0, 0, 0);
                if (today >= opendate) {
                  window.open(this.currentConference.surveyurl)
                } else {
                  this.$message("会议召开后才能填写")
                }
              }
              return
            }
            if (this.$store.state.conference.currentConference) {
              if (
                this.$store.state.conference.currentConference.status !== "发布"
              ) {
                this.$message("请点击首页，更新当前会议")
                return
              }
            }
            this.$router.push({ name: path, params: { userId: "" } })
          } else {
            this.$message("请先登录")
          }
        }
        //会议直播
        if (path == "LivePage") {
          if (this.$store.state.conference.currentConference) {
            if (this.$store.state.conference.currentConference.liveurl) {
              window.open(
                this.$store.state.conference.currentConference.liveurl,
                "_blank"
              )
            } else {
              this.$message("尚未开始直播")
            }
          }
          return
        }
        //会议信息
        if (path == "MeetingPage") {
          this.$router.push({ name: path, params: { userId: "" } })
        }
      },
    },

    // watch: {
    //     tools: {
    //         handler(newVal) {
    //             this.options = newVal;
    //         },
    //         immediate: true,
    //     },
    // },
  }
</script>

<style lang="scss" scoped>
  .tool-item {
    @include flex-start;

    .tool-text {
      margin-left: 15px;

      .tit {
        font-size: 20px;
        margin-bottom: 10px;
        transition: color 0.3s ease-out;
      }

      .sub {
        color: #999;
        font-size: 14px;
        transition: color 0.3s ease-out;
      }
    }
  }
</style>